import React from 'react';

const styles = {
  base: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    gap: 8, border: 'none', borderRadius: 8,
    fontWeight: 600, cursor: 'pointer', transition: 'all 0.15s ease',
    fontSize: 'var(--font-size-base)', lineHeight: 1,
  },
  primary: {
    // V5（2026-05-20）：accent #1f53e6 替代 V4 navy #1a3a6b。
    // 影响范围：所有 <Button variant="primary">；V4 老页面会比之前略亮一些，但语义不变。
    background: '#1f53e6', color: '#fff',
    padding: '12px 28px',
  },
  secondary: {
    background: 'transparent', color: '#1f53e6',
    border: '1.5px solid #1f53e6', padding: '11px 27px',
  },
  ghost: {
    background: 'transparent', color: 'var(--color-text-secondary)',
    padding: '11px 20px',
  },
  danger: {
    background: '#dc2626', color: '#fff',
    padding: '8px 18px',
  },
  sm: { padding: '8px 18px', fontSize: 'var(--font-size-sm)' },
  lg: { padding: '14px 36px', fontSize: 'var(--font-size-md)' },
  full: { width: '100%' },
  disabled: { opacity: 0.5, cursor: 'not-allowed' },
};

export default function Button({
  children, variant = 'primary', size, fullWidth, disabled, loading, onClick, type = 'button', style,
}) {
  const s = {
    ...styles.base,
    ...styles[variant],
    ...(size ? styles[size] : {}),
    ...(fullWidth ? styles.full : {}),
    ...(disabled || loading ? styles.disabled : {}),
    ...style,
  };
  return (
    <button type={type} style={s} disabled={disabled || loading} onClick={onClick}>
      {loading ? '处理中...' : children}
    </button>
  );
}
